import {
  ITechnologyResource,
  ITechnologyResources,
} from "../../../../models/master/technologyResource";
import { baseURL } from "../../../../constants/commonConstants";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { useNavigate } from "react-router-dom";
import { IStaffTechnologyResouce } from "../../../../models/dashboard/staffDashboard";
import { connect, useDispatch } from "react-redux";
import { useEffect } from "react";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { setTechnologyResources } from "../../../../store/slices/master/technologyResourceSlice";
import { getTechnologyResources } from "../../../../action/masters/technologyResourceActionCreator";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const TechnoloryResourses = (props: IStaffTechnologyResouce) => {
  const { getTechnologyResources, technologyResources, snapShots } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const pageBlockData = getPageBlockData(
    snapShots,
    pageBlockId.technologyResources
  );

  const handleViewALL = () => {
    navigate(ROUTER_URL.STAFF_ALL_TECHNOLOGY_RESOURCES);
  };

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getTechnologyResources(pageBlockId.technologyResources, limit.three);
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setTechnologyResources([]));
    };
  }, []);

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="title">
          <h2>Technology Resources</h2>
          <a
            onClick={handleViewALL}
            className={
              pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
            }
            title="View All Technology Resources"
          >
            View All
          </a>
        </div>
        <ul className="transactions-wrap mt-3 mb-0">
          {technologyResources?.map((alert: ITechnologyResources) => (
            <li>
              <a href={alert.url} target="_blank">
                <div className="img icon">
                  <img src={baseURL + alert.image} alt="" />
                </div>
                <div>
                  <h3>{alert.resourceName}</h3>
                  <p className="para-hide-1">{alert.description}</p>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getTechnologyResources: (pageBlockId?: number, noOfItems?: number) =>
    getTechnologyResources(undefined, pageBlockId, undefined, undefined, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    technologyResources: state.technologyResource.technologyResources,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TechnoloryResourses);
